import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import cx from 'classnames';
import True from 'modules/common/Svg/True';
import False from 'modules/common/Svg/False';
import decodeId from 'core/libs/helpers/decodeId';
import {
  stepsLine,
  stepsLineSmallOnMobile,
  bgRed,
  bgGreen,
  stepsLineActiveGreen,
  stepsLineActiveRed,
} from './styles.scss';

const QuizTimeLine = ({currentPosition, tasks}) => {
  return (
    <div className="pv3 tc">
      <ul
        className={cx('pa0 ma0', stepsLine, {
          [stepsLineSmallOnMobile]: tasks.length > 3,
        })}
      >
        {tasks.map(({id, passed, isCorrect}, index) => (
          <li
            key={`task-${id}`}
            className={cx('dib mh3 bg-near-white relative', {
              [bgGreen]: passed && isCorrect,
              [bgRed]: passed && !isCorrect,
              [`${stepsLineActiveGreen} bg-blue-light active white`]:
                passed && isCorrect && index <= currentPosition,
              [`${stepsLineActiveRed} bg-blue-light active white`]:
                passed && !isCorrect && index <= currentPosition,
            })}
          >
            {passed ? (
              <div>
                {isCorrect ? (
                  <True unBoxed color="#fff" className="mt1 dib v-mid" />
                ) : (
                  <False unBoxed color="#fff" className="mt1 dib v-mid" />
                )}
              </div>
            ) : (
              index + 1
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

QuizTimeLine.propTypes = {
  currentPosition: PropTypes.number.isRequired,
  tasks: PropTypes.array.isRequired,
};

export default connect(({quizzes: {tasksHistory}}, {tasks}) => ({
  tasks: tasks.map(({node: task}) => {
    const id = decodeId(task.id);
    return {
      ...task,
      passed: typeof tasksHistory[id] !== 'undefined',
      isCorrect: tasksHistory[id],
    };
  }),
}))(QuizTimeLine);
